const IGNORED_ROW_PATTERNS = [
  'Booked orders totals',
  'Salesperson totals',
  'Bill onlys totals',
  'Credit memos totals',
  'Hold orders totals',
  'Incomplete orders totals',
  'Deleted orders total',
  'Back orders total',
  'OC (order code)'
]

export function parseSalespersonHeader(cell) {
  const match = cell.match(/Sl\s*#\s*(\d+)\s+(.*)/)
  if (!match) return null

  return {
    id: Number(match[1]),
    name: match[2].trim()
  }
}

export function normalizeExcelDate(value){
  if (!value) return null

  if (value instanceof Date) {
    return value.toISOString().split('T')[0]
  }

  if (typeof value === 'number') {
    const epoch = new Date(Date.UTC(1899, 11, 30))
    epoch.setDate(epoch.getDate() + value)
    return epoch.toISOString().split('T')[0]
  }

  if (typeof value === 'string') {
    const d = new Date(value)
    if (!isNaN(d.getTime())) {
      return d.toISOString().split('T')[0]
    }
  }

  return null
}

export function isIgnoredRow(row) {
  const firstCell = String(row[0] ?? '').trim()
  return IGNORED_ROW_PATTERNS.some(p => firstCell.includes(p))
}